'use client';

import { forwardRef } from '@chakra-ui/react';
import ReactCurrencyInput, {
  CurrencyInputProps as ReactCurrencyInputProps,
} from 'react-currency-input-field';

import { Input, InputProps } from './Input';

type Props = Omit<ReactCurrencyInputProps, 'color' | 'size'> & InputProps;

export type CurrencyInputProps = Props;

export const CurrencyInput = forwardRef<Props, 'input'>((props, ref) => {
  return (
    <Input
      decimalSeparator=","
      groupSeparator="."
      suffix=" €"
      allowNegativeValue={false}
      {...props}
      ref={ref}
      as={ReactCurrencyInput}
      inputMode="text"
    />
  );
});
